module.exports = __webpack_public_path__ + "img/Jian_Li.c4775f23.png";